import {DisplayConfig} from "../Config";

import './Video.css'
import ReactPlayer from "react-player/file";
import {DisplayCommand, PlayVideo as PlayVideoType, ShowOnlineResults} from "../../javaTypes";
import {useEffect, useState} from "react";
import Video from "./Video";

export default function PlayVideo({config, command, nowCallback} : {
    config: DisplayConfig,
    command: DisplayCommand<PlayVideoType>,
    nowCallback: () => number,
}) {
    const [isDone, setIsDone] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        setIsDone(false);
        setIsPlaying(false);

        // Wait 1 second to allow other displays to synchronize
        const timeout = setTimeout(() => {
            setIsPlaying(true);
        }, (command.ts + 1000) - nowCallback());

        return () => clearTimeout(timeout);
    }, [command.ts]);

    if(isDone) {
        return <Video config={config} />
    }

    return <div className={"h-100 w-100"} key={command.ts}>
        <ReactPlayer playing={isPlaying} url={command.params.videoUrl} width={"1920px"} height={"1080px"} muted={config.mute} config={{
            tracks: command.params.subtitleUrl ? [
                // They may not be English, but since there's only one and we force it on, it doesn't matter
                { kind: 'subtitles', src: command.params.subtitleUrl, srcLang: 'en', label: 'Subtitles', default: true }
            ] : []
        }} onReady={(p) => {
            const video = p.getInternalPlayer() as HTMLVideoElement
            if(video.textTracks.length > 0) {
                video.textTracks[0].mode = 'showing'
            }
            // In theory this makes sense, but in practice this seems to get into a loop?
            // if(nowCallback() > command.ts + 1000) {
            //     // Catch up to where we should be (to the nearest second anyways)
            //     p.seekTo((nowCallback() - command.ts + 1000) / 1000, 'seconds');
            // }
        }} onEnded={() => {
            setTimeout(() => {
                setIsDone(true);
            }, 1000);
        }}></ReactPlayer>
    </div>
}